module.exports = __webpack_public_path__ + "img/table-bg-xxl.a8b8301.webp";